import React, { Component } from "react"
import { Alert } from "reactstrap"

const typeToColorMapping = {
    error: "danger",
    success: "success",
    info: "info",
    warning: "warning"
}

class AlertComponent extends Component {
    constructor(props) {
        super(props)
        this.alertTimeout = null
        this.onToggle = this.onToggle.bind(this)
    }

    componentDidMount() {
        const { id, dismiss, timeout } = this.props
        if (timeout && dismiss)
            this.alertTimeout = setTimeout(() => dismiss(id), timeout)
    }

    componentWillUnmount() {
        if (this.alertTimeout) {
            clearTimeout(this.alertTimeout)
            this.alertTimeout = null
        }
    }

    onToggle() {
        this.props.dismiss(this.props.id)
    }

    render() {
        const { type, message, header, className } = this.props
        const color = typeToColorMapping[type]
        return (
            <Alert color={color} className={className} toggle={this.onToggle}>
                {header && [
                    <strong key="header">{header}</strong>,
                    <br key="header-line" />
                ]}
                {message}
            </Alert>
        )
    }
}

export default AlertComponent
